import React, { useEffect, useRef } from "react";
import { TURNSTILE_SITE_KEY } from "../config/environment";

// Cloudflare Turnstile widget for the signup form (docs/bot-signup-abuse.md).
// Rendered explicitly from the shared api.js script; Turnstile injects a
// hidden `cf-turnstile-response` input into the container, which sits inside
// the form, so the token rides along in the form data.
//
// The site key comes from config/environment like the other client config;
// when it's empty this renders nothing and loads nothing, and the backend
// (with no secret configured) accepts tokenless signups.

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export function TurnstileWidget({ className }) {
    const containerRef = useRef(null);

    useEffect(() => {
        const key = TURNSTILE_SITE_KEY;
        if (!key || !containerRef.current) return undefined;

        let widgetId = null;
        let cancelled = false;
        const renderWidget = () => {
            if (cancelled || widgetId !== null) return;
            if (window.turnstile && containerRef.current) {
                widgetId = window.turnstile.render(containerRef.current, { sitekey: key });
            }
        };

        if (window.turnstile) {
            renderWidget();
        } else {
            let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
            if (!script) {
                script = document.createElement("script");
                script.src = SCRIPT_SRC;
                script.async = true;
                document.head.appendChild(script);
            }
            script.addEventListener("load", renderWidget);
        }

        return () => {
            cancelled = true;
            if (widgetId !== null && window.turnstile) {
                window.turnstile.remove(widgetId);
            }
        };
    }, []);

    if (!TURNSTILE_SITE_KEY) return null;
    return <div ref={containerRef} className={className} />;
}
